export const isNullOrUndefined = (value: any) =>
  value === null || value === undefined;

export function isNumeric(str: string): boolean {
  if (str.trim() === "") return false;
  return !isNaN(Number(str));
}
